// extracted by mini-css-extract-plugin
module.exports = {"main":"Admin_main__3mIo2","container":"Admin_container__2I3pV","header":"Admin_header__Ozh7w","main1":"Admin_main1__1vDLx","cards":"Admin_cards__2l-L8"};